import IdPasswordChange from './IdPasswordChange'

export default IdPasswordChange;